<template>
  <v-card class="pa-4">
    <v-card-title class="d-flex align-center mt-2 mb-2">
      <v-icon class="mr-2">mdi-package</v-icon>
      <h3 class="mb-0">
        Empaquetado - <strong>#{{ selectedOrder?.code }}</strong>
      </h3>
    </v-card-title>
    <v-card-text>
      <v-alert type="success" variant="tonal" class="mb-4">
        <h6 class="">
          <span class="font-weight-medium text-success-darken-2">Validación Completada</span>
        </h6>
        <h6 class="mb-0">
          Todos los items han sido validados y distribuidos en
          {{ packages.length }} bulto(s)
        </h6>
      </v-alert>

      <div class="mb-4">
        <h5 class="font-weight-medium mb-3">
          Contenido de cada bulto:
        </h5>

        <v-row>
          <v-col v-for="pkg in packages" :key="pkg.id" cols="12" md="6">
            <v-card elevation="0" class="pa-3 h-100 rounded-lg card-bultos">
              <v-card-title class="text-h6 pb-2 d-flex justify-space-between">
                <div>
                  <h4 class="mb-0">Bulto {{ pkg.id }}</h4>
                </div>
                <div>
                  <v-chip size="small" variant="tonal" color="primary">
                    {{
                      pkg.items.reduce((acc, item) => acc + item.amount, 0)
                    }}
                    items
                  </v-chip>
                </div>
              </v-card-title>

              <v-card-text class="pt-2">
                <div v-if="pkg.items.length === 0" class="text-center text-grey-500">
                  <p class="text-card mb-0">Sin items</p>
                </div>

                <PackageItemList v-else :items="pkg.items" :package-id="pkg.id" :show-remove-button="false" />
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <v-card class="mb-4 pa-3" color="#D0EBFF" elevation="0">
        <v-card-text>
          <h3 class="font-weight-bold mb-3">Resumen del Empaquetado:</h3>
          <p class="text-card mb-1">Pedido: {{ selectedOrder?.code }}</p>
          <p class="text-card mb-1">Cliente: {{ selectedOrder?.client.name }}</p>
          <p class="text-card mb-1">Items: {{ totalValidated }}</p>
          <p class="text-card mb-1">Bultos: {{ packages.length }}</p>
        </v-card-text>
      </v-card>

      <div class="d-flex flex-column">       
        <v-btn ref="printButton" color="primary" @click="handlePrintLabels" @keydown.enter="handlePrintLabels" size="large" block :loading="loading_print_labels">
          <v-icon start>mdi-printer</v-icon>
          Imprimir {{ packages.length }} Etiqueta(s)
        </v-btn>
        <v-btn @click="$emit('back-step')"  @keydown.enter="$emit('back-step')" variant="outlined" color="#2e3d45" size="large" class="mt-2" block>
          <v-icon start>mdi-arrow-left</v-icon>
          Volver
        </v-btn>
      </div>

    </v-card-text>
  </v-card>
</template>

<script>
import AliasMixin from '@/mixins/AliasMixin.vue';
import PackageItemList from "@/components/Packages/PackageItemList.vue";

export default {
  name: "PackageOrder",
  mixins: [AliasMixin],
  components: {
    PackageItemList
  },
  props: {
    selectedOrder: {
      type: Object,
      default: null,
    },
    packages: {
      type: Array,
      default: () => [],
    },
    loading_print_labels: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["labels-printed", "back-step"],
  computed: {
    totalValidated() {
      return (
        this.selectedOrder?.items.reduce(
          (acc, item) => acc + item.validated,
          0
        ) || 0
      );
    },
  },
  methods: {
    handlePrintLabels() {
      this.$emit("labels-printed");
    },
  },
};
</script>

<style scoped>
.text-card {
  font-size: 0.875rem;
  color: #374151;
}
</style>
